import React, { useEffect, useRef, useState } from 'react';
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';

import { GetCompaniesList, PostPerformActivity } from '../services/httpServices';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

export default function Association(props) {
  let { id, checkClient } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState({});
  const [roles, setRoles] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [saved, setSaved] = useState(false);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [selectedRole, setSelectedRole] = useState(null);
  const [message, setMessage] = useState('');

  const activityTypeRef = useRef('');
  const activitiyDateRef = useRef('');
  const activityTimeRef = useRef('');
  const followUpDateRef = useRef('');
  const commentsRef = useRef('');
  const nextStageRef = useRef('');

  const fetchCompanies = async (event) => {
    const companies = await GetCompaniesList();

    setCompanies(companies);
    setLoading(false);
    //console.log('checkClient', checkClient);
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  const PerformActivity = async (event) => {
    event.preventDefault();
    //console.log('editHit');
    setLoading(true);
    const payload = {
      activityType: activityTypeRef.current.value,
      activityDate: activitiyDateRef.current.value,
      activityTime: activityTimeRef.current.value,
      followUpDate: followUpDateRef.current.value,
      comments: commentsRef.current.value,
      nextStage: nextStageRef.current.value,
      clientId: checkClient == 'true' ? id : null,
      companyId: checkClient == 'false' ? id : null,
    };

    //console.log(payload);
    let response = await PostPerformActivity(payload);
    //console.log('PostResponse:', response);
    if (response.status == 200) {
      setMessage(response.data);
      setSaved(true);
      setOpen(true);
      setLoading(false);
      setTimeout(() => {
        navigate(`/app/MyOpportunities`);
      }, 2000);
    } else {
      setMessage(response.data);
      setSaved(false);
      setOpen(true);
      setLoading(false);
      // setPosting(false);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Helmet>
        <title> Employer Association | Immigration System </title>
      </Helmet>

      <Container>
        <form onSubmit={PerformActivity}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              Associate Client with Employer
            </Typography>
            {/* <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}> */}

            <Stack direction="row" spacing={2}>
              <Button
                onClick={() => {
                  navigate(-1);
                }}
                variant="contained"
              >
                Back
              </Button>
              <Button type="submit" variant="contained">
                Save
              </Button>
            </Stack>
          </Stack>
          {loading ? (
            <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
              <CircularProgress size={60} thickness={3} value={100} />
            </Grid>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box component={Paper} p={4}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={4} md={4}>
                      <TextField
                        label="Select Employer"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={activityTypeRef}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4} md={4}>
                      <Autocomplete
                        id="role"
                        size="small"
                        options={roles}
                        defaultValue={roles.find((e) => e.key == user.userRoleId)}
                        getOptionLabel={(role) => role.value}
                        renderInput={(params) => (
                          <TextField
                            required
                            {...params}
                            // defaultValue={selectedRole}
                            // inputRef={userRoleRef}
                            label="Next Stage"
                            variant="outlined"
                          />
                        )}
                        onChange={(event, role) => setSelectedRole(role)}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          )}
        </form>
        {saved ? (
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            key={vertical + horizontal}
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
              {message}
            </Alert>
          </Snackbar>
        ) : (
          <Snackbar
            key={vertical + horizontal}
            anchorOrigin={{ vertical, horizontal }}
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
              {message}
            </Alert>
          </Snackbar>
        )}
      </Container>

    </>
  );
}
